import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingPermissions: false,
  errorLoadingPermissions: null,
  permissions: [],
};

export const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setLoadingPermissions: (state) => {
      state.loadingPermissions = true;
    },
    setErrorLoadingPermissions: (state, action) => {
      state.loadingPermissions = false;
      state.errorLoadingPermissions = action.payload;
    },
    setPermissions: (state, action) => {
      state.loadingPermissions = false;
      state.errorLoadingPermissions = null;
      state.permissions = action.payload;
    },
  },
});

export const {
  setLoadingPermissions,
  setErrorLoadingPermissions,
  setPermissions,
} = permissionSlice.actions;

export default permissionSlice.reducer;

export const permissionSelector = (state) => state.permission;
